import { ref } from "vue";

// Global state for auth modal - shared across all components
const showAuthModal = ref(false);
const authModalDefaultTab = ref<"signin" | "signup">("signin");
const authModalReturnPath = ref<string | null>(null);

export const useAuthModal = () => {
  const openAuthModal = (
    tab: "signin" | "signup" = "signin",
    returnPath?: string
  ) => {
    authModalDefaultTab.value = tab;
    authModalReturnPath.value = returnPath || null;
    showAuthModal.value = true;
  };

  const closeAuthModal = () => {
    showAuthModal.value = false;
    authModalReturnPath.value = null;
  };

  return {
    showAuthModal,
    authModalDefaultTab,
    authModalReturnPath,
    openAuthModal,
    closeAuthModal,
  };
};
